<template>
    <div v-if="active" :class="{easter: true, mobile: mobile()}">
        <a v-show="! infoOpen" href="#" class="close" @click="close()"></a>
        <full-page class="fullPage" ref="fullpage" :options="options" @after-load="afterLoad">
            <div class="section intro">
                <div class="header">
                    <h1 class="osternAuf">OSTERN AUF</h1>
                    <h1 class="wersglaubt">WERSGLAUBT.AT</h1>
                </div>

                <h3 class="question">Was haben der Osterhase und die Auferstehung gemeinsam?</h3>
                <img class="scroll" src="@/assets/easter/scroll.svg" @click="nextScene">

            </div>
            <div class="section article" id="easterArticle" ref="article">
                <div class="easterText">
                    <h2>Der Osterhase und die Auferstehung</h2>
                    <p>Das sind doch beides nur Märchen, oder? Die leibliche Auferstehung Jesu von
                        den Toten ist tatsächlich aber das zentrale Thema in der christlichen Ostergeschichte.
                        Auferstehung bedeutet für Christen neues Leben, Sieg über den Tod, Sieg über die Sünden und die
                        Versöhnung mit Gott. Wenn der historische Jesus nicht von den Toten auferstanden ist, so ist das
                        ganze Christentum eine moralische Lehre ohne Hoffnung.<br>
                        Wenn er aber den Tod überwinden konnte, so hält die
                        Osterbotschaft auch heute noch die Message für dich bereit: Gott bietet dir einen Sieg über
                        ungesunde Bindungen und zerstörerisches Denken und Verhalten an, dazu Versöhnung mit ihm und
                        ewiges Leben. Es liegt an dir, dieses Ostergeschenk zu ergreifen.</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p><em>Jesus: "Ich bin die Auferstehung und das Leben. Wer an mich glaubt, wird leben, auch wenn er
                        stirbt.
                        Und wer lebt und an mich glaubt, wird niemals sterben. Glaubst du das?" (Johannes 11,25-26)</em>
                    </p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>

                    <h2>4 Gründe für die Auferstehung von Jesus </h2>
                    <p><br></p>
                    <p><strong>1. Jesus ist wirklich am Kreuz gestorben</strong></p>
                    <p>Auferstehen kann nur jemand, der zuvor gestorben ist. Die Bibel, außerbiblische Quellen
                        sowie moderne medizinische Erkenntnisse bezeugen den
                        Tod von Jesus. Neben den Berichten in den Evangelien (= Lebensberichte über Jesus) finden wir
                        Hinweise
                        über Jesu Tod bei Autoren aus der Zeit nach Jesus. Darunter Ignatius, Klemens und die
                        nichtchristlichen
                        Schreiber Tacitus und Josephus.</p>
                    <span class="more" @click="openInfo(0)">Mehr dazu...</span>
                    <p>&nbsp;</p>
                    <p><strong>2. Das Grab war wirklich leer</strong></p>
                    <p>Sechs voneinander unabhängige Quellen berichten vom leeren Grab. Einige davon zählen zu den
                        frühesten
                        Quellen des Neuen Testaments. Die Reaktion der jüdischen Führer beweist ebenso, dass das Grab
                        leer war.
                        Als sie davon hörten, setzten sie das Gerücht in die Welt, dass die Jünger trotz römischer
                        Bewachung den
                        Körper von Jesus gestohlen hätten. Damit bestätigen sie, dass Jesus aus dem Grab verschwunden
                        war. Der
                        Körper war nicht mehr da, das Grab war leer. Das Gegenteil hätte leicht bewiesen werden können,
                        indem
                        man die Leiche vorweist. Dies war jedoch nicht möglich.</p>
                    <span class="more" @click="openInfo(1)">Mehr dazu...</span>
                    <p>&nbsp;</p>
                    <p><em>&nbsp;„Weitaus die meisten Exegeten halten an der Zuverlässigkeit der biblischen Aussagen
                        über das
                        leere Grab fest.“</em></p>
                    <p><em>&nbsp;(Jacob Kremer, Universitätsprofessor für Neutestamentliche Bibelwissenschaft
                        Universität
                        Wien)</em></p>
                    <p>&nbsp;</p>
                    <p><strong>3. Die Augenzeugen</strong></p>
                    <p>Die ersten Augenzeugen waren Frauen. Dieses Detail unterstützt die Glaubwürdigkeit der Berichte.
                        Warum?
                        Paradoxerweise genau deshalb, weil die Zeugenaussage einer Frau in der damaligen Zeit überhaupt
                        keinen
                        Wert besaß. Wer eine Lüge in die Welt setzen wollte, hätte niemals die Zeugenaussagen von Frauen
                        eingebaut. Doch genau das lesen wir in den Evangelien - was wiederum nahelegt, dass es sich
                        genauso
                        ereignet hat. Wäre der Bericht erfunden worden, so hätten die Männer jener Zeit dafür gesorgt,
                        dass sie
                        selbst nicht als diejenigen dargestellt werden, die sich aus Angst versteckt hielten. Während
                        sie allen
                        Mut verloren, wurde den Frauen die Ehre zuteil, vor ihnen dem Auferstandenen zu begegnen.</p>
                    <p>&nbsp;</p>
                    <p>In einem der frühesten Paulusbriefe finden wir eine Liste von Menschen, die den Auferstandenen
                        mit
                        eigenen Augen gesehen haben. Zuerst Petrus, dann der Kreis der zwölf, dann 500 Menschen
                        gleichzeitig,
                        dann Jakobus, dann alle Apostel, schließlich auch Paulus, der zu diesem Zeitpunkt noch ein
                        erbitterter
                        Gegner der Christen war. Durch die Begegnung mit dem auferstandenen Jesus wurde der Verfolger
                        der
                        christlichen Lehre zum Verbreiter derselben. Und damit selbst zum Verfolgten.</p>
                    <span class="more" @click="openInfo(2)">Mehr dazu...</span>
                    <p>&nbsp;</p>
                    <p><strong>4. Die Verwandlung der Apostel</strong></p>
                    <p>Zum Zeitpunkt der Kreuzigung waren die Apostel alles andere als mutig. Kein Wunder – hieß doch
                        die
                        Hinrichtung als Verbrecher nach jüdischem Verständnis, dass jemand unter Gottes Fluch stand. Sie
                        waren
                        wohl einer Lüge auf den Leim gegangen, hatten auf das falsche Pferd gesetzt. Selbst Petrus
                        verleugnete
                        Jesus. Nach der Begegnung mit dem Auferstandenen waren ausnahmslos alle bereit zu leiden und für
                        das,
                        was sie als Wahrheit ansahen, zu sterben. Ihr Glauben war dermaßen stark, dass kein einziger von
                        ihnen
                        seine Meinung änderte – nicht einmal im Angesicht des Todes. Das zeigt, dass sie wirklich davon
                        überzeugt waren, dass Gott Jesus von den Toten auferweckt hat. Das Christentum erhielt trotz
                        Verfolgung
                        und Widerstand einen Auftrieb, der es zur Weltreligion anwachsen ließ. Man kann den Aufstieg des
                        frühen
                        Christentums ohne eine echte Auferstehung von Jesus nicht erklären. [2]</p>
                    <!--<span class="more" @click="openInfo(3)">Mehr dazu...</span>-->
                    <p>&nbsp;</p>
                    <p><em>"Eine Art kraftvolle, transformative Erfahrung ist erforderlich, um die Art von Bewegung zu
                        erzeugen, die das frühe Christentum war."</em></p>
                    <p><em>(Luke Timothy Johnson, Professor für Neues Testament, Emory Universität)</em></p>

                    <p><br></p>
                    <p><br></p>
                    <h2>Schau dir mal diese links an:</h2>
                    <p>[1] <a href="https://youtu.be/-HP8vG-HxO8" target="_blank">4 Gründe für die Auferstehung von
                        Jesus</a> (youtube)</p>
                    <p>[2] <a href="https://youtu.be/h3MRccitu2Q" target="_blank">Ist Jesus wirklich auferstanden?</a>
                        (youtube)</p>
                    <p><a href="https://youtu.be/4qhQRMhUK1o" target="_blank">Did Jesus Rise from the Dead? - Part One:
                        The
                        Facts</a> (youtube, englisch)</p>
                    <p><a href="https://youtu.be/6SbJ4p6WiZE" target="_blank">Did Jesus Rise from the Dead? - Part Two:
                        The
                        Explanation</a> (youtube, englisch)</p>
                    <br>
                    <p><b><a href="/Die%20Tatsache%20der%20Auferstehung.pdf" download>Die Tatsache der Auferstehung</a>
                        (Buch kostenlos als PDF herunterladen)</b></p>
                    <p><br></p>

                </div>
            </div>
        </full-page>

        <img v-show="(! infoOpen) && infoButtonActive()" src="@/assets/easter/infoIcon.svg" id="infoButton"
             class="infoIcon pulse" @click="openInfo">
        <Info ref="info" :open="infoOpen" @close="closeInfo()" :infoArray="info"/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import Start from "@/components/christmas/Start";
    import Tutorial from "@/components/christmas/Tutorial";
    import BasicComponent from "@/components/BasicComponent";
    import Info from "@/components/easter/Info";

    @Component({
        components: {Info},
    })
    export default class Easter extends BasicComponent {

        data() {
            return {
                active: false,
                index: 0,
                infoOpen: false,
                pageBefore: null,
                info: [
                    {
                        title: "Jesus war wirklich tot",
                        lastOfType: true
                    },
                    {
                        title: "Jesus wirklich auferstanden",
                        lastOfType: true
                    },
                    {
                        title: "Bewertung der Augenzeugen",
                        lastOfType: true
                    },/*
                    {
                        title: "Apostel",
                        lastOfType: true
                    }*/
                ],
                options: {
                    licenseKey: "381A4FF0-3A544E43-878AC729-E8EDDCD1",
                    afterLoad: this.afterLoad,
                    normalScrollElements: "#infoContent, #easterArticle",
                }
            };
        }


        created() {
            if (this.$cookie.get("easter") === "closed") {
                this.$data.active = false;
                return;
            }
            //this.open();
        }

        mounted() {
        }

        infoButtonActive() {
            return this.index > 1 && this.index < 7;
        }

        animateInfoButton() {
            const el = document.getElementById("infoButton");
            setTimeout(() => {
                el.classList.remove("pulse");
            }, 2000);
        }

        close() {
            this.$data.active = false;
            this.$cookie.set("easter", "closed", {expires: 30});
            this.trackPage("Startseite")
            this.trackEvent('Ostern', "Osterseite geschlossen");
        }

        open() {
            this.$data.active = true;
            this.$cookie.delete("easter");
            this.trackPage("Ostern")
        }

        openInfo(index) {
            const info = this.$refs.info;
            info.openArticles([index]);
            this.$data.infoOpen = true;
            this.$data.pageBefore = this.getCurrentPageName();
        }

        closeInfo() {
            this.$data.infoOpen = false;
            this.trackPage("Ostern")
            this.trackPage(this.getCurrentPageName());
            this.trackEvent('Ostern - Zusatzinfos geschlossen', this.info[index].title);
        }

        getCurrentPageName() {
            return "Ostern";
        }

        nextScene() {
            this.$refs.fullpage.api.moveSectionDown();
        }

        afterLoad(origin, destination, direction) {
            if (destination.index === 1) {
                this.$refs.fullpage.api.setAllowScrolling(false);
                this.$refs.article.style["overflow-y"] = "scroll";
                console.log(".");
            }
        }

    }
</script>
<style scoped lang="scss">

    .easter {
        height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        z-index: 1000;
        background: url("/easterBackground.svg"), white;
        background-size: cover;
        background-position: bottom center;
        background-repeat: no-repeat;

        .intro {
            position: relative;

            .header {
                position: absolute;
                top: 30vh;
                left: 50%;
                transform: translateX(-50%);

                @media screen and (max-width: 800px) {
                    top: auto;
                    bottom: 2.5vh;
                }


                h1 {
                    font-size: 60px;
                    text-align: center;

                    @media screen and (max-width: 800px) {
                        font-size: 30px;
                        color: #414f26;
                    }

                    @media screen and (max-width: 375px) {
                        font-size: 25px;
                    }
                }

                .osternAuf {
                    font-family: 'Permanent Marker', cursive;
                }

                .wersglaubt {
                    font-variant: normal;
                    font-weight: 600;
                }
            }


            .question {
                color: #414f26;

                position: absolute;
                bottom: 8vh;
                text-align: center;
                width: 100%;

                font-family: 'Permanent Marker', cursive;

                font-size: 50px;

                @media screen and (max-width: 800px) {
                    font-size: 40px;
                    padding: 0;
                    color: black;

                    bottom: auto;
                    top: 30vh;
                }

                @media screen and (max-width: 375px) {
                    font-size: 30px;
                }
            }

            .scroll {
                position: absolute;
                bottom: 20px;
                left: 50%;
                transform: translateX(-50%);
                width: 70px;
                z-index: 1010;
                cursor: pointer;

                @media screen and (max-width: 800px) {
                    display: none;
                }
            }
        }

        .article {

            $titleFontSize: 40px;

            width: 90vw;
            max-width: 1000px;
            height: 100vh;
            margin: 0 auto;
            padding-top: 40px;
            padding-bottom: -40px;
            padding-left: 5%;
            padding-right: 5%;
            overflow-y: hidden;

            background-color: rgba(255, 255, 255, 0.9);
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);

            .blabla {
                height: 180px;
                margin-right: 100%;
                max-width: 90vw;
            }

            .label {
                position: relative;
                right: 6px;
                text-align: right;
                font-weight: 900;
                font-size: $titleFontSize;
                font-variant: small-caps;
                margin-bottom: -26px;
                line-height: 1;
            }

            .easterText {
                font-size: 20px;
                line-height: 30px;
                text-align: left;
                hyphens: auto;

                padding: 15px;
                padding-bottom: 60px;

                h2 {
                    margin-bottom: 10px;
                }

                * {
                    hyphens: auto;
                }
            }
        }
    }

    .close {
        position: absolute;
        right: 32px;
        top: 32px;
        width: 32px;
        height: 32px;
        opacity: 0.3;
        z-index: 3000;

        @media screen and (max-width: 375px) {
            top: 20px;
            right: 20px;
        }
    }

    .close:hover {
        opacity: 1;
    }

    .close:before, .close:after {
        position: absolute;
        left: 15px;
        content: ' ';
        height: 33px;
        width: 2px;
        background-color: #333;
    }

    .close:before {
        transform: rotate(45deg);
    }

    .close:after {
        transform: rotate(-45deg);
    }

    .infoIcon {
        position: fixed;
        bottom: 0;
        right: 0;
        transform: translate(25%, 25%);

        &:hover {
            cursor: pointer;
        }
    }

    .more {
        //color: #5cb0eb;
        cursor: pointer;
        text-decoration: underline;
        font-weight: bold;
    }


</style>
<style lang="scss">

    .easter {

        .pulse {
            -webkit-animation-name: pulsate;
            -webkit-animation-duration: 1s;
            -webkit-animation-timing-function: ease-in-out;
            -webkit-animation-iteration-count: infinite
        }

        @-webkit-keyframes pulsate {
            0% {
                transform: scale(1.0) translate(25%, 25%)
            }
            10% {
                transform: scale(1.05) translate(24%, 24%)
            }
            20% {
                transform: scale(1.10) translate(23%, 23%)
            }
            30% {
                transform: scale(1.15) translate(22%, 22%)
            }
            40% {
                transform: scale(1.20) translate(21%, 21%)
            }
            50% {
                transform: scale(1.25) translate(20%, 20%)
            }
            60% {
                transform: scale(1.20) translate(21%, 21%)
            }
            70% {
                transform: scale(1.15) translate(22%, 22%)
            }
            80% {
                transform: scale(1.10) translate(23%, 23%)
            }
            90% {
                transform: scale(1.05) translate(24%, 24%)
            }
            100% {
                transform: scale(1.0) translate(25%, 25%)
            }
        }
    }

</style>
